import script from "./PmMorphIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PmMorphIcon.vue?vue&type=script&setup=true&lang=js"

import "./PmMorphIcon.vue?vue&type=style&index=0&id=77591f14&lang=scss&scoped=true"

import exportComponent from "../../preview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77591f14"]])

export default __exports__